export const menuJson = [
    {
        "id": 1,
        "level": 1,
        "title": "Tableau de bord",
        "label": "Patrimoine",
        "data": "0-0-0-tableau-de-bord",
        "headCode": "vue-generale",
        "icon": "home",
        "path": "/dashboard",
        "type": "link",
        "active": true,
        "expanded": true,
        "children": []
    },
    // {
    //     "id": 2,
    //     "level": 2,
    //     "title": "Patrimoine",
    //     "label": "Patrimoine",
    //     "data": "1-0-0-patrimoine",
    //     "headCode": "gestion",
    //     "icon": "disc",
    //     "type": "sub",
    //     "statut": false,
    //     "children": [
    //         {
    //             "path": "/patrimony/sim-card",
    //             "title": "Mes cartes SIM",
    //             "label": "Mes cartes SIM",
    //             "data": "1-1-0-cartes-sim",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/patrimony/white-sim-card",
    //             "title": "Mes cartes SIM blanches",
    //             "label": "Mes cartes SIM blanches",
    //             "data": "1-8-0-cartes-sim-blanche",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/patrimony/data-balance-status",
    //             "title": "Etat des Soldes Data",
    //             "label": "Etat des Soldes Data",
    //             "data": "1-2-0-etat-solde-data",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/patrimony/sms-balance-status",
    //             "title": "Etat des Soldes SMS",
    //             "label": "Etat des Soldes SMS",
    //             "data": "1-9-0-etat-solde-sms",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/patrimony/download",
    //             "title": "Mes téléchargements",
    //             "label": "Mes téléchargements",
    //             "data": "1-6-0-telechargement",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/patrimony/sim-importation",
    //             "title": "Mes importations SIM",
    //             "label": "Mes importations SIM",
    //             "data": "9-6-0-importation-sim",
    //             "type": "link"
    //         }
    //     ]
    // },
    // {
    //     "id": 3,
    //     "level": 3,
    //     "title": "Demandes de Services",
    //     "label": "Demandes de Services",
    //     "data": "9-0-0-demandes-de-services",
    //     "headCode": "gestion",
    //     "expanded": true,
    //     "statut": false,
    //     "icon": "pen-tool",
    //     "type": "sub",
    //     "children": [
    //         {
    //             "path": "/requests-services/mobile-subscriptions",
    //             "title": "Mes abonnements mobiles",
    //             "label": "Mes abonnements mobiles",
    //             "data": "9-1-0-activations-mobile",
    //             "type": "link"
    //         }
    //     ]
    // },
    // {
    //     "id": 4,
    //     "level": 4,
    //     "title": "Commandes de Produits",
    //     "label": "Demandes de Produits",
    //     "data": "11-0-0-commande-de-produit",
    //     "headCode": "gestion",
    //     "expanded": true,
    //     "statut": false,
    //     "icon": "pen-tool",
    //     "type": "sub",
    //     "children": [
    //         {
    //             "path": "/requests-products/white-sim",
    //             "title": "Mes commandes SIM",
    //             "label": "Mes commandes SIM",
    //             "data": "11-1-0-commande-sim-blanche",
    //             "type": "link"
    //         }
    //     ]
    // },
    // {
    //     "id": 5,
    //     "level": 5,
    //     "title": "Référentiel de supervision",
    //     "label": "Référentiel de supervision",
    //     "data": "2-0-0-referentiel-telemetrie",
    //     "headCode": "gestion",
    //     "expanded": true,
    //     "statut": false,
    //     "icon": "thermometer",
    //     "type": "sub",
    //     "children": [
    //         {
    //             "path": "/ref-supervision/indicateurs-alarmes",
    //             "title": "Indicateurs & Alarmes",
    //             "label": "Indicateurs & Alarmes",
    //             "data": "2-1-0-seuil-alarmes",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/ref-supervision/profil-supervision",
    //             "title": "Profils de supervision",
    //             "label": "Profils de supervision",
    //             "data": "2-2-0-profil-supervision",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/ref-supervision/accords-sla",
    //             "title": "Accords SLA",
    //             "label": "Accords SLA",
    //             "data": "2-3-0-accords-sla",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/ref-supervision/contact-sla",
    //             "title": "Contacts Gestion SLA",
    //             "label": "Contacts Gestion SLA",
    //             "data": "2-4-0-contact-sla",
    //             "type": "link"
    //         }
    //     ]
    // },
    // {
    //     "id": 6,
    //     "level": 6,
    //     "title": "Suivi Demandes P&S",
    //     "label": "Suivi Demandes P&S",
    //     "data": "4-0-0-suivi-operations",
    //     "headCode": "gestion",
    //     "expanded": true,
    //     "statut": false,
    //     "icon": "airplay",
    //     "type": "sub",
    //     "children": [
    //         {
    //             "path": "/overseeing-operations/waiting",
    //             "title": "Files d'attente",
    //             "label": "Files d'attente",
    //             "data": "4-1-0-fil-attente",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/overseeing-operations/treatment-monitoring",
    //             "title": "Suivi et traitement",
    //             "label": "Suivi et traitement",
    //             "data": "4-2-0-suivi-traitement",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/overseeing-operations/notifications",
    //             "title": "Mes Notifications",
    //             "label": "Mes Notifications",
    //             "data": "4-5-0-notifications",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/overseeing-operations/messaging",
    //             "title": "Ma messagerie",
    //             "label": "Ma messagerie",
    //             "data": "4-7-0-messagerie",
    //             "type": "link"
    //         }
    //     ]
    // },
    // {
    //     "id": 7,
    //     "level": 7,
    //     "title": "Suivi de l'identification",
    //     "label": "Suivi de l'identification",
    //     "data": "10-0-0-gestion-identifications",
    //     "headCode": "gestion",
    //     "expanded": true,
    //     "statut": false,
    //     "icon": "airplay",
    //     "type": "sub",
    //     "children": [
    //         {
    //             "path": "/gestion-identifications/file-attente",
    //             "title": "Files d'attente",
    //             "label": "Files d'attente",
    //             "data": "10-1-0-file-attente",
    //             "type": "link"
    //         }
    //     ]
    // },
    // {
    //     "id": 8,
    //     "level": 8,
    //     "title": "Supervision des SIM",
    //     "label": "Supervision des SIM",
    //     "data": "5-0-0-supervision-sim",
    //     "headCode": "gestion",
    //     "expanded": true,
    //     "statut": false,
    //     "icon": "activity",
    //     "type": "sub",
    //     "children": [
    //         {
    //             "path": "/zone-trafic/zone-exploitation",
    //             "title": "Zone de Trafic",
    //             "label": "Zone de Trafic",
    //             "data": "5-1-0-zone-trafic",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/supervision-sim/analyse-alarmes-data",
    //             "title": "Analyse des Alarmes DATA",
    //             "label": "Analyse des Alarmes DATA",
    //             "data": "5-2-0-analyse-alarmes-data",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/supervision-sim/analyse-alarmes-sms",
    //             "title": "Analyse des Alarmes SMS",
    //             "label": "Analyse des Alarmes SMS",
    //             "data": "5-3-0-analyse-alarmes-sms",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/supervision-sim/detection-appro-data",
    //             "title": "Détection Appro. Data",
    //             "label": "Détection Appro. Data",
    //             "data": "5-4-0-detection-appro-data",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/supervision-sim/detection-appro-sms",
    //             "title": "Détection Appro. SMS",
    //             "label": "Détection Appro. SMS",
    //             "data": "5-5-0-detection-appro-sms",
    //             "type": "link"
    //         }
    //     ]
    // },
    // {
    //     "id": 9,
    //     "level": 9,
    //     "title": "Comptabilité",
    //     "label": "Comptabilité",
    //     "data": "12-0-0-comptabilite",
    //     "headCode": "gestion",
    //     "expanded": true,
    //     "statut": false,
    //     "icon": "dollar-sign",
    //     "type": "sub",
    //     "children": [
    //         {
    //             "path": "/accounting/reload-my-account",
    //             "title": "Mes crédits de compte",
    //             "label": "Mes crédits de compte",
    //             "data": "12-4-0-credit-compte",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/accounting/my-invoices",
    //             "title": "Mes factures",
    //             "label": "Mes factures",
    //             "data": "12-1-0-facture",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/accounting/my-payments",
    //             "title": "Mes paiements",
    //             "label": "Mes paiements",
    //             "data": "12-5-0-mes-paiements",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/accounting/my-account",
    //             "title": "Mon relevé de compte",
    //             "label": "Mon relevé de compte",
    //             "data": "12-3-0-releve-compte",
    //             "type": "link"
    //         }
    //     ]
    // },
    // {
    //     "id": 10,
    //     "level": 10,
    //     "title": "Reporting SLA",
    //     "label": "Reporting SLA",
    //     "data": "8-0-0-sla-demandes-de-services",
    //     "headCode": "gestion",
    //     "expanded": true,
    //     "statut": false,
    //     "icon": "clock",
    //     "type": "sub",
    //     "children": [
    //         {
    //             "path": "/sla-demande-service/dashboard-folders",
    //             "title": "Tableau de bord dossiers",
    //             "label": "Tableau de bord dossiers",
    //             "data": "8-1-0-dashboard-dossier",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/sla-demande-service/dashboard-demands",
    //             "title": "Tableau de bord demandes",
    //             "label": "Tableau de bord demandes",
    //             "data": "8-2-0-dashboard-demandes",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/sla-demande-service/rapport-performances",
    //             "title": "Rapport Performances",
    //             "label": "Rapport Performances",
    //             "data": "8-2-0-rapport-de-conformite",
    //             "type": "link"
    //         }
    //     ]
    // },
    // {
    //     "id": 7,
    //     "level": 7,
    //     "title": "Paramètre & Sécurité",
    //     "label": "Paramètre & Sécurité",
    //     "data": "6-0-0-parametres-securite",
    //     "headCode": "administration",
    //     "expanded": true,
    //     "statut": false,
    //     "icon": "settings",
    //     "type": "sub",
    //     "children": [
    //     ]
    // },
    {
        "id": 6,
        "level": 6,
        "title": "Bon de livraisons",
        "label": "Bon de livraisons",
        "data": "8-0-0-bill-of-ladings",
        "headCode": "administration",
        "expanded": true,
        "statut": false,
        "icon": "bar-chart-2",
        "type": "sub",
        "children": [
            {
                "path": "/bill-of-ladings/importations",
                "title": "Importations de BL",
                "label": "Importations de BL",
                "data": "8-1-0-bill-of-ladings-importations",
                "type": "link"
            },
            {
                "path": "/bill-of-ladings/purchase-orders",
                "title": "Liste des BC",
                "label": "Liste des BC",
                "data": "8-2-0-purchase-orders",
                "type": "link"
            },
            {
                "path": "/bill-of-ladings/delivery-notes",
                "title": "Liste des LV",
                "label": "Liste des LV",
                "data": "8-3-0-delivery-notes",
                "type": "link"
            },
            {
                "path": "/bill-of-ladings/shipping-notes",
                "title": "Liste des BE",
                "label": "Liste des BE",
                "data": "8-6-0-shipping-notes",
                "type": "link"
            },
            {
                "path": "/bill-of-ladings/inspection-statements",
                "title": "Etat des contrôles",
                "label": "Etat des contrôles",
                "data": "8-4-0-inspection-statements",
                "type": "link"
            },
            {
                "path": "/bill-of-ladings/cim-ivoire-delivery-notes",
                "title": "LV CIMIVOIRE",
                "label": "LV CIMIVOIRE",
                "data": "8-5-0-cim-ivoire-delivery-notes",
                "type": "link"
            },
        ]
    },
    {
        "id": 6,
        "level": 6,
        "title": "Gestion des missions",
        "label": "Gestion des missions",
        "data": "7-0-0-structure-orga",
        "headCode": "administration",
        "expanded": true,
        "statut": false,
        "icon": "bar-chart-2",
        "type": "sub",
        "children": [
            {
                "path": "/missions-management/missions",
                "title": "Liste des missions",
                "label": "Liste des missions",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/missions-management/travels",
                "title": "Liste des voyages",
                "label": "Liste des voyages",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            // {
            //     "path": "/missions-management/fuel-receipts",
            //     "title": "Bons de carburant",
            //     "label": "Bons de carburant",
            //     "data": "7-1-0-structure-orga-niveau-1",
            //     "type": "link"
            // },
            // {
            //     "path": "/missions-management/fees",
            //     "title": "Calcul frais de mission",
            //     "label": "Calcul frais de mission",
            //     "data": "7-1-0-structure-orga-niveau-1",
            //     "type": "link"
            // },
            {
                "path": "/missions-management/settings",
                "title": "Paramétrage itinéraires",
                "label": "Paramétrage itinéraires",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
        ]
    },
    {
        "id": 6,
        "level": 6,
        "title": "État des missions",
        "label": "État des missions",
        "data": "7-0-0-structure-orga",
        "headCode": "administration",
        "expanded": true,
        "statut": false,
        "icon": "bar-chart-2",
        "type": "sub",
        "children": [
            {
                "path": "/mission-statements/fees",
                "title": "État des frais de route",
                "label": "État des frais de route",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/mission-statements/weighing",
                "title": "État des pesages",
                "label": "État des pesages",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/mission-statements/fuel-vouchers",
                "title": "Bon de carburant divers",
                "label": "Bon de carburant divers",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
        ]
    },
    {
        "id": 6,
        "level": 6,
        "title": "Produits & Chargements",
        "label": "Produits & Chargements",
        "data": "7-0-0-structure-orga",
        "headCode": "administration",
        "expanded": true,
        "statut": false,
        "icon": "bar-chart-2",
        "type": "sub",
        "children": [
            {
                "path": "/mission-statements/loading-vouchers",
                "title": "Bon de chargements",
                "label": "Bon de chargements",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/mission-statements/unloading-vouchers",
                "title": "Bon de déchargements",
                "label": "Bon de déchargements",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/mission-statements/loading-unloading-vouchers",
                "title": "État des déchargements",
                "label": "État des déchargements",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
        ]
    },
    {
        "id": 6,
        "level": 6,
        "title": "Facturations",
        "label": "Facturations",
        "data": "9-0-0-billing",
        "headCode": "administration",
        "expanded": true,
        "statut": false,
        "icon": "bar-chart-2",
        "type": "sub",
        "children": [
            {
                "path": "/billing/carrier-statements",
                "title": "État transporteurs",
                "label": "État transporteurs",
                "data": "9-1-0-carrier-statements",
                "type": "link"
            },
            {
                "path": "/billing/carrier-invoices",
                "title": "Factures transporteurs",
                "label": "Factures transporteurs",
                "data": "9-2-0-carrier-invoices",
                "type": "link"
            },
        ]
    },
    {
        "id": 6,
        "level": 6,
        "title": "Gestion de la caisse",
        "label": "Gestion de la caisse",
        "data": "7-0-0-cash-management",
        "headCode": "administration",
        "expanded": true,
        "statut": false,
        "icon": "bar-chart-2",
        "type": "sub",
        "children": [
            {
                "path": "/cash-management/cash-in-receipts",
                "title": "Bon de caisse d'entrée",
                "label": "Bon de caisse d'entrée",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/cash-management/cash-out-receipts",
                "title": "Bon de caisse de sortie",
                "label": "Bon de caisse de sortie",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/cash-management/all-cash-receipts",
                "title": "Tous les bons de caisse",
                "label": "Tous les bons de caisse",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/cash-management/cash-receipt-statements",
                "title": "État des bons de caisse",
                "label": "État des bons de caisse",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
        ]
    },
    {
        "id": 6,
        "level": 6,
        "title": "Parc automobile",
        "label": "Parc automobile",
        "data": "7-0-0-structure-orga",
        "headCode": "administration",
        "expanded": true,
        "statut": false,
        "icon": "bar-chart-2",
        "type": "sub",
        "children": [
            {
                "path": "/vehicule-fleet/drivers",
                "title": "Liste des chauffeurs",
                "label": "Liste des chauffeurs",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/vehicule-fleet/inspectors",
                "title": "Liste des contrôleurs",
                "label": "Liste des contrôleurs",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/vehicule-fleet/vehicule-brands",
                "title": "Marques de véhicules",
                "label": "Marques de véhicules",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/vehicule-fleet/tractors",
                "title": "Liste des tracteurs",
                "label": "Liste des tracteurs",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/vehicule-fleet/tippers",
                "title": "Liste des bennes",
                "label": "Liste des bennes",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/vehicule-fleet/trucks",
                "title": "Liste des camions",
                "label": "Liste des camions",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/vehicule-fleet/destinations",
                "title": "Liste des destinations",
                "label": "Liste des destinations",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/vehicule-fleet/weighing-addresses",
                "title": "Lieux de pesage",
                "label": "Lieux de pesage",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/vehicule-fleet/loading-vouchers-addresses",
                "title": "Lieux de char/déchargement",
                "label": "Lieux de char/déchargement",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/vehicule-fleet/fuel-station-brands",
                "title": "Marques de stations",
                "label": "Marques de stations",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/vehicule-fleet/fuel-stations",
                "title": "Liste des stations",
                "label": "Liste des stations",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
        ]
    },
    {
        "id": 6,
        "level": 6,
        "title": "Partenaires",
        "label": "Partenaires",
        "data": "7-0-0-structure-orga",
        "headCode": "administration",
        "expanded": true,
        "statut": false,
        "icon": "bar-chart-2",
        "type": "sub",
        "children": [
            {
                "path": "/partners-management/carriers",
                "title": "Liste des fournisseurs",
                "label": "Liste des fournisseurs",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            },
            {
                "path": "/partners-management/clients",
                "title": "Liste des clients",
                "label": "Liste des clients",
                "data": "7-1-0-structure-orga-niveau-1",
                "type": "link"
            }
        ]
    },
    {
        "id": 6,
        "level": 6,
        "title": "Paramètres & Sécurité",
        "label": "Paramètres & Sécurité",
        "data": "14-0-0-settings-and-security",
        "headCode": "administration",
        "expanded": true,
        "statut": false,
        "icon": "settings",
        "type": "sub",
        "children": [
            {
                "path": "parametre-securite/profils-habilitations",
                "title": "Profils Habilitations",
                "label": "Profils Habilitations",
                "data": "6-1-0-profils-habilitations",
                "type": "link"
            },
            {
                "path": "/parametre-securite/utilisateurs",
                "title": "Utilisateurs",
                "label": "Utilisateurs",
                "data": "6-2-0-utilisateurs",
                "type": "link"
            },
            // {
            //     "path": "/parametre-securite/journaux-authentification",
            //     "title": "Journal des accès",
            //     "label": "Journal des accès",
            //     "data": "6-3-0-journaux-auth",
            //     "type": "link"
            // },
            {
                "path": "/settings-and-security/base-settings",
                "title": "Paramètres de base",
                "label": "Paramètres de base",
                "data": "14-1-0-base-settings",
                "type": "link"
            },
        ]
    },
    // {
    //     "id": 6,
    //     "level": 6,
    //     "title": "Structure Organisationnelle",
    //     "label": "Structure Organisationnelle",
    //     "data": "7-0-0-structure-orga",
    //     "headCode": "administration",
    //     "expanded": true,
    //     "statut": false,
    //     "icon": "bar-chart-2",
    //     "type": "sub",
    //     "children": [
    //         {
    //             "path": "/structure-organisationnelle/niveau-1",
    //             "title": "Départements",
    //             "label": "Départements",
    //             "data": "7-1-0-structure-orga-niveau-1",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/structure-organisationnelle/niveau-2",
    //             "title": "Communes / Sous Préfecture",
    //             "label": "Communes / Sous Préfecture",
    //             "data": "7-2-0-structure-orga-niveau-2",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/structure-organisationnelle/niveau-3",
    //             "title": "Types Emplacements",
    //             "label": "Types Emplacements",
    //             "data": "7-3-0-structure-orga-niveau-3",
    //             "type": "link"
    //         },
    //         {
    //             "path": "/structure-organisationnelle/usage-metier",
    //             "title": "Usages Métier",
    //             "label": "Usages Métier",
    //             "data": "7-4-0-structure-orga-usage",
    //             "type": "link"
    //         }
    //     ]
    // },
]